import React from 'react';

import { CardCtn } from '../jobCard/index.style';
import { Body, TitleBar, DetailBar } from './index.style';

/**
 * Faint empty rows that hold a list's place while its data loads, each the size of a real job card (it reuses the real
 * card's wrapper, so the spacing matches at every width). Home's lists show at most four rows, so four of these mean
 * nothing below the list moves when the real rows arrive. They are not loaders: they do not move, count or announce
 * anything, and they look like the faint grey zeros on the cards above, for the same reason - an empty version of the
 * page that fills in.
 */
interface GhostCardsProps {
  count?: number;
}

const GhostCards: React.FC<GhostCardsProps> = ({ count = 4 }): React.ReactElement => {
  return (
    <React.Fragment>
      {Array.from({ length: count }).map((_, index) => (
        <CardCtn key={index} aria-hidden="true">
          <Body>
            <TitleBar />
            <DetailBar />
          </Body>
        </CardCtn>
      ))}
    </React.Fragment>
  );
};

export default GhostCards;
